import { MediaType } from '@/types/NewsFeed'
import { Accept } from 'react-dropzone'

// File size limits
const SIZE_LIMIT_VIDEO: number = 20_000_000 // 20MB
const SIZE_LIMIT_IMAGE: number = 5_000_000 // 5MB
const SIZE_LIMIT_PDF: number = 5_000_000 // 5MB

// File count limits
export const FILE_LIMIT_IMAGE: number = 10
const FILE_LIMIT_VIDEO: number = 1
const FILE_LIMIT_PDF: number = 5

// Default image dimensions
export const DEFAULT_IMAGE_WIDTH: number = 1600
export const DEFAULT_IMAGE_HEIGHT: number = 1200

// Accepted MIME types
export const ACCEPTED_IMAGE_TYPES: string[] = ['image/jpeg', 'image/jpg', 'image/png'] as const
export const ACCEPTED_VIDEO_TYPES: string[] = ['video/mp4', 'video/webm', 'video/quicktime'] as const
export const ACCEPTED_PDF_TYPES: string[] = ['application/pdf'] as const

export const ACCEPTED_MIME_TYPES: Accept = {
    'image/jpeg': [],
    'image/jpg': [],
    'image/png': [],
    'application/pdf': [],
    'video/mp4': [],
    'video/webm': [],
    'video/quicktime': []
} as const

function getSizeLimitByMediaType(mediaType: MediaType): number {
    switch (mediaType) {
        case MediaType.IMAGE:
            return SIZE_LIMIT_IMAGE
        case MediaType.VIDEO:
            return SIZE_LIMIT_VIDEO
        case MediaType.PDF:
            return SIZE_LIMIT_PDF
        default:
            return SIZE_LIMIT_IMAGE
    }
}

export function getFileLimitByMediaType(mediaType: MediaType): number {
    switch (mediaType) {
        case MediaType.IMAGE:
            return FILE_LIMIT_IMAGE
        case MediaType.VIDEO:
            return FILE_LIMIT_VIDEO
        case MediaType.PDF:
            return FILE_LIMIT_PDF
        default:
            return FILE_LIMIT_IMAGE
    }
}

export function getMediaTypeFromMime(mimeType: string): MediaType | null {
    if (ACCEPTED_IMAGE_TYPES.includes(mimeType as (typeof ACCEPTED_IMAGE_TYPES)[number])) {
        return MediaType.IMAGE
    }
    if (ACCEPTED_VIDEO_TYPES.includes(mimeType as (typeof ACCEPTED_VIDEO_TYPES)[number])) {
        return MediaType.VIDEO
    }
    if (ACCEPTED_PDF_TYPES.includes(mimeType as (typeof ACCEPTED_PDF_TYPES)[number])) {
        return MediaType.PDF
    }
    return null
}

export function isFileSizeValid(file: File, mediaType: MediaType): boolean {
    return file.size <= getSizeLimitByMediaType(mediaType)
}

const EXTENSION_TO_MIME: Record<string, string> = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    mp4: 'video/mp4',
    webm: 'video/webm',
    mov: 'video/quicktime'
}

export function getMimeTypeFromFileName(fileName: string): string {
    const extension: string | undefined = fileName.split('.').pop()?.toLowerCase()
    if (!extension) return ''
    return EXTENSION_TO_MIME[extension] ?? ''
}
